/* eslint-disable react/prop-types */
import React from "react";
import { ProductCard } from "./ProductCard";

export const ProductList = ({
  products,
  onQuantityChange,
  getCurrentQuantity,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {products.map((product) => (
        <ProductCard
          key={product._id}
          product={product}
          onQuantityChange={(product, quantity, selectedAddon) =>
            onQuantityChange(product, quantity, selectedAddon)
          }
          quantity={getCurrentQuantity(product._id)}
        />
      ))}
    </div>
  );
};